export default __webpack_public_path__ + "static/media/BGS.0d4333ab.png";